(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ntw-shop-reviews"] && !Shopify.designMode) return;
  try {
    
  const createTextElement = (tag, className, text) => {
    const element = document.createElement(tag);
    element.className = className;
    element.textContent = text;
    return element;
  };

  const createReviewCard = (review) => {
    const card = document.createElement('a');
    card.className = 'ntw-shop-review-card';
    card.href = review.review_url || '#';
    card.setAttribute('aria-label', `${review.rating} star Shop review from ${review.name}`);

    const header = document.createElement('div');
    header.className = 'ntw-shop-review-card__header';
    header.append(
      createTextElement('p', 'ntw-shop-review-card__name', review.name),
      createTextElement('div', 'ntw-shop-review-card__stars', '★'.repeat(Number(review.rating) || 5))
    );

    const variant = [review.product_name, review.variant].filter(Boolean).join(' ');
    const meta = document.createElement('div');
    meta.className = 'ntw-shop-review-card__meta';
    meta.append(
      createTextElement('p', 'ntw-shop-review-card__source', 'Source: Shop'),
      createTextElement('p', 'ntw-shop-review-card__date', review.date)
    );

    card.append(
      header,
      createTextElement('p', 'ntw-shop-review-card__verified', 'Verified by Shop'),
      createTextElement('p', 'ntw-shop-review-card__variant', variant),
      createTextElement('p', 'ntw-shop-review-card__quote', `"${review.quote}"`),
      meta
    );

    return card;
  };

  const setupCarousel = (carousel) => {
    const track = carousel.querySelector('[data-ntw-shop-reviews-track]');
    const previous = carousel.querySelector('[data-ntw-shop-reviews-prev]');
    const next = carousel.querySelector('[data-ntw-shop-reviews-next]');

    if (!track || !previous || !next || track.dataset.ntwShopReviewsReady === 'true') return;
    track.dataset.ntwShopReviewsReady = 'true';

    const getStep = () => {
      const card = track.querySelector('.ntw-shop-review-card');
      if (!card) return track.clientWidth;

      const styles = window.getComputedStyle(track);
      return card.getBoundingClientRect().width + Number.parseFloat(styles.columnGap || styles.gap || 0);
    };

    const updateButtons = () => {
      const maxScroll = track.scrollWidth - track.clientWidth - 2;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
    };

    previous.addEventListener('click', () => track.scrollBy({ left: -getStep(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: getStep(), behavior: 'smooth' }));
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    updateButtons();
  };

  document.querySelectorAll('[data-ntw-shop-reviews]').forEach(async (section) => {
    const handle = section.dataset.productHandle;
    const source = section.dataset.reviewsSrc;
    const track = section.querySelector('[data-ntw-shop-reviews-track]');

    if (!handle || !source || !track) return;

    try {
      const response = await fetch(source, { credentials: 'same-origin' });
      if (!response.ok) return;

      const data = await response.json();
      const reviews = data.products?.[handle] || [];
      if (!reviews.length) return;

      track.replaceChildren(...reviews.map(createReviewCard));
      section.hidden = false;
      setupCarousel(section.querySelector('[data-ntw-shop-reviews-carousel]'));
    } catch (error) {
      console.warn('Unable to load NTW Shop reviews', error);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
